import _defineProperty from "C:\\Users\\R c\\Desktop\\Hactric\\eksplode\\eksplode-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
var _excluded = ["children", "className", "disabled", "disabledClassName", "focus", "id", "selected", "selectedClassName", "tabIndex", "tabRef"];
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React, { useEffect, useRef } from "react";
import cx from "clsx";
var DEFAULT_CLASS = "react-tabs__tab";
var defaultProps = {
  className: DEFAULT_CLASS,
  disabledClassName: "".concat(DEFAULT_CLASS, "--disabled"),
  focus: false,
  id: null,
  selected: false,
  selectedClassName: "".concat(DEFAULT_CLASS, "--selected")
};
var Tab = function Tab(props) {
  var nodeRef = useRef();
  var _defaultProps$props = Object.assign({}, defaultProps, props),
    children = _defaultProps$props.children,
    className = _defaultProps$props.className,
    disabled = _defaultProps$props.disabled,
    disabledClassName = _defaultProps$props.disabledClassName,
    focus = _defaultProps$props.focus,
    id = _defaultProps$props.id,
    selected = _defaultProps$props.selected,
    selectedClassName = _defaultProps$props.selectedClassName,
    tabIndex = _defaultProps$props.tabIndex,
    tabRef = _defaultProps$props.tabRef,
    attributes = _objectWithoutPropertiesLoose(_defaultProps$props, _excluded);
  useEffect(function () {
    if (selected && focus) {
      nodeRef.current.focus();
    }
  }, [selected, focus]);
  return React.createElement("li", Object.assign({}, attributes, {
    className: cx(className, _defineProperty(_defineProperty({}, selectedClassName, selected), disabledClassName, disabled)),
    ref: function ref(node) {
      nodeRef.current = node;
      if (tabRef) tabRef(node);
    },
    role: "tab",
    id: "tab".concat(id),
    "aria-selected": selected ? "true" : "false",
    "aria-disabled": disabled ? "true" : "false",
    "aria-controls": "panel".concat(id),
    tabIndex: tabIndex || (selected ? "0" : null),
    "data-rttab": true
  }), children);
};
Tab.tabsRole = "Tab";
export default Tab;